import { safetyMargins, HD, FULL_HD } from '@bedrock-rdk/constants';
import { FONT, getFont } from '@tornado-rdk/typography';
import { TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../tornado/utils/style';
import { middle, SCREEN_HEIGHT, SCREEN_WIDTH } from '../../tornado/utils/sizes';
import { ICON_TYPE } from '../../tornado/icon/icon.constants';

export const BRAND_ICON_SIZE = {
  [HD]: 64,
  [FULL_HD]: 72,
};

const ARROW_PADDING_BOTTOM = {
  [HD]: 24,
  [FULL_HD]: 32,
};
const ARROW_SIZE = {
  [HD]: 96,
  [FULL_HD]: 128,
};

const CONTENT_SIDE_MARGIN = {
  [HD]: 300,
  [FULL_HD]: 460,
};

const TITLE_PADDING_BOTTOM = {
  [HD]: 24,
  [FULL_HD]: 56,
};

const DESCRIPTION_PADDING_BOTTOM = {
  [HD]: 24,
  [FULL_HD]: 25,
};

const defaultContext = makeDefaultStylingContext();

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const topY = safetyMargins.vertical[screenSize];
  const scrollWrapperY = topY + ARROW_SIZE[screenSize] + ARROW_PADDING_BOTTOM[screenSize];
  const scrollWrapperWidth = SCREEN_WIDTH[screenSize] - CONTENT_SIDE_MARGIN[screenSize] * 2;
  const scrollWrapperHeight =
    SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize] - scrollWrapperY - ARROW_SIZE[screenSize];
  const titleFont = getFont(FONT.KINSHASA_3, screenSize);
  const descriptionFont = getFont(FONT.MADRID_1, screenSize);
  const backgroundColor = makeThemeColor(TERTIARY);

  return {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    Background: {
      rect: true,
      w: SCREEN_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
      color: backgroundColor[colorMode],
    },
    BackButton: {
      x: safetyMargins.horizontal[screenSize],
      y: topY,
    },
    ArrowUp: {
      y: topY,
      mountX: 0.5,
      x: middle,
      visible: false,
      iconData: {
        picto: {
          name: 'ArrowUp',
          type: ICON_TYPE.SIMPLE_ICON,
        },
        viewBox: {
          h: ARROW_SIZE[screenSize],
        },
      },
    },
    BrandIcon: {
      h: BRAND_ICON_SIZE[screenSize],
      y: topY,
      mountX: 0.5,
      x: middle,
    },
    ScrollWrapper: {
      mountX: 0.5,
      x: middle,
      y: scrollWrapperY,
      w: scrollWrapperWidth,
      h: scrollWrapperHeight,
      clipping: true,
      ScrollContent: {
        flex: { direction: 'column' },
        Title: {
          mountX: 0.5,
          flexItem: { marginBottom: TITLE_PADDING_BOTTOM[screenSize] },
          x: middle,
          text: {
            ...titleFont,
          },
        },
        Description: {
          mountX: 0.5,
          x: middle,
          flexItem: { marginBottom: DESCRIPTION_PADDING_BOTTOM[screenSize] },
          text: {
            wordWrapWidth: scrollWrapperWidth,
            ...descriptionFont,
          },
        },
        CookieGroups: {
          flex: { direction: 'column' },
        },
      },
    },
    ArrowDown: {
      mountY: 1,
      y: SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize],
      mountX: 0.5,
      x: middle,
      visible: false,
      iconData: {
        picto: {
          name: 'ArrowDown',
          type: ICON_TYPE.SIMPLE_ICON,
        },
        viewBox: {
          h: ARROW_SIZE[screenSize],
        },
      },
    },
  };
};

export const gridPadding = {
  left: 224,
};
